import {
  listUsers,
  createUser,
  updateUser,
  deleteUser,
  updateStatus,
  getElmsForFeature,
  getSuperiors,
  changePassword as changePasswordService,
  updateInfor,
  getElmsByGroups,
} from "app/services/user.service";

import {
  USER_REQUEST,
  USER_FAILURE,
  FETCH_USERS_SUCCESS,
  CREATE_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  GET_USER_SUCCESS,
  AUTH_SET_USER,
  AUTH_LOGOUT,
  UPDATE_STATUS_USER_SUCCESS,
  FETCH_ELMS_FOR_FEATURE_SUCCESS,
  APPEND_ELMS_FOR_FEATURE_SUCCESS,
  FETCH_SUPERIORS_SUCCESS,
  FETCH_ELMS_BY_GROUPS_SUCCESS,
} from "./types";

export const setAuthUser = (user) => ({
  type: AUTH_SET_USER,
  payload: user,
});

export const clearAuthUser = () => ({
  type: AUTH_LOGOUT,
});

export const userRequest = () => ({
  type: USER_REQUEST,
});

export const userFailure = (error) => ({
  type: USER_FAILURE,
  payload: error,
});

export const fetchUsersSuccess = (data) => ({
  type: FETCH_USERS_SUCCESS,
  payload: data,
});

export const createUserSuccess = (user) => ({
  type: CREATE_USER_SUCCESS,
  payload: user,
});

export const updateUserSuccess = (user) => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
});

export const deleteUserSuccess = (id) => ({
  type: DELETE_USER_SUCCESS,
  payload: id,
});

export const getUserSuccess = (user) => ({
  type: GET_USER_SUCCESS,
  payload: user,
});

export const updateUserStatusSuccess = (user) => ({
  type: UPDATE_STATUS_USER_SUCCESS,
  payload: user,
});

export const fetchUsers = (params) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await listUsers(params);

      dispatch(fetchUsersSuccess(res));
      return res;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error ||
        resData?.message ||
        "Lỗi khi tải danh sách người dùng";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const addUser = (userData) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await createUser({ data: userData });
      dispatch(createUserSuccess(res));
      return res;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tạo người dùng";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const editUser = (id, userData) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await updateUser({ id, data: userData });
      dispatch(updateUserSuccess(res));
      return res;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi cập nhật người dùng";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const updateStatusUser = (id) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await updateStatus({ id });
      dispatch(updateUserStatusSuccess(res));
      return res;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error ||
        resData?.message ||
        "Lỗi khi cập nhật trạng thái người dùng";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const removeUser = (id) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      await deleteUser({ id });
      dispatch(deleteUserSuccess(id));
      return true;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi xóa người dùng";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const fetchElmsForFeature = (params = {}, isLoadMore = false) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await getElmsForFeature({ ...params });
      dispatch({
        type: isLoadMore
          ? APPEND_ELMS_FOR_FEATURE_SUCCESS
          : FETCH_ELMS_FOR_FEATURE_SUCCESS,
        payload: res.data,
      });
      return res;
    } catch (error) {
      const messageText =
        error?.response?.data?.message || "Lỗi khi tải danh sách cán bộ";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const fetchElmsByGroups = () => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await getElmsByGroups();
      dispatch({
        type: FETCH_ELMS_BY_GROUPS_SUCCESS,
        payload: res.data,
      });
      return res;
    } catch (error) {
      const messageText =
        error?.response?.data?.message || "Lỗi khi tải danh sách cán bộ";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const fetchSuperiors = (params = {}) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await getSuperiors(params);
      dispatch({
        type: FETCH_SUPERIORS_SUCCESS,
        payload: res.data,
      });
      return res;
    } catch (error) {
      const messageText =
        error?.response?.data?.message ||
        "Lỗi khi tải danh sách người phụ trách";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const changeUserPassword = (
  id,
  oldPassword,
  newPassword,
  confirmPassword,
) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      await changePasswordService(
        id,
        oldPassword,
        newPassword,
        confirmPassword,
      );
      return true;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi đổi mật khẩu";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const updateUserInfoAction = (id, fullName, phone, avatarUrl, rank) => {
  return async (dispatch) => {
    dispatch(userRequest());
    try {
      const res = await updateInfor({ id, fullName, phone, avatarUrl, rank });
      dispatch(updateUserSuccess(res));
      return res;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi cập nhật thông tin";
      dispatch(userFailure(messageText));
      throw new Error(messageText);
    }
  };
};
